import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter, initialClientGeneral, initialClientAddress, initialClientEmail, initialTelephoneEmail } from './ClientByIdUIHelpers';

const ClientByIdUIContext = createContext();

export function useClientUIContext () {
    return useContext(ClientByIdUIContext);
}

export const ClientByIdUIConsumer = ClientByIdUIContext.Client;

export function ClientUIProvider ({ ClientUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [clientGeneral, setClientGeneralBase] = useState(initialClientGeneral);
    const [clientAddress, setClientAddressBase] = useState(initialClientAddress);
    const [clientEmail, setClientEmailBase] = useState(initialClientEmail);
    const [clientTelephone, setClientTelephoneBase] = useState(initialTelephoneEmail);
    const [clientTabData, setClientTabData] = useState();
    const [accountId, setAccountId] = useState(null);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const setClientGeneral = useCallback(nextClientGeneral => {
        setClientGeneralBase(prevClientGeneral => {
            if (isEqual(prevClientGeneral, nextClientGeneral)) {
                return prevClientGeneral;
            }

            return nextClientGeneral;
        });
    }, []);

    const setClientAddress = useCallback(nextClientAddress => {
        setClientAddressBase(prevClientAddress => {
            if (isEqual(nextClientAddress, prevClientAddress)) {
                return prevClientAddress;
            }

            return nextClientAddress;
        });
    }, []);

    const setClientEmail = useCallback(nextClientEmail => {
        setClientEmailBase(prevClientEmail => {
            if (isEqual(nextClientEmail, prevClientEmail)) {
                return prevClientEmail;
            }

            return nextClientEmail;
        });
    }, []);
    const setClientTelephone = useCallback(nextClientTelephone => {
        setClientTelephoneBase(prevClientTelephone => {
            if (isEqual(nextClientTelephone, prevClientTelephone)) {
                return prevClientTelephone;
            }

            return nextClientTelephone;
        });
    }, []);

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        clientGeneral,
        setClientGeneral,
        clientAddress,
        setClientAddress,
        clientEmail,
        setClientEmail,
        clientTabData,
        setClientTabData,
        clientTelephone,
        setClientTelephone,
        accountId,
        setAccountId
    };

    return <ClientByIdUIContext.Provider value={value}>{children}</ClientByIdUIContext.Provider>;
}
